import { EQuizMode } from '@constants';
import { IGenerateQuiz } from '@sdk/contracts';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useQuizForm } from '@/hooks';
import { sdk } from '@/services';
import { buildQuizUrl, mapGeneratedQuestionsData } from '@/utils';

const QuizService = sdk.getService('QuizService');

export const useGenerateQuiz = (mode: EQuizMode, isFromBaseContent?: boolean) => {
  const { setQuestions, setConfigOpen } = useQuizForm();
  const navigateTo = useNavigate();
  const { t } = useTranslation('ManagerQuizzesTranslations');

  const { mutate: generateQuiz, isPending } = useMutation({
    mutationFn: (generateQuizParams: IGenerateQuiz) => QuizService.generateQuiz(generateQuizParams),
    onSuccess: generatedQuestions => {
      setQuestions(mapGeneratedQuestionsData(generatedQuestions, mode, t));
      setConfigOpen(false);
      navigateTo(buildQuizUrl({ isFromBaseContent }));
    }
  });

  return { generateQuiz, isWorking: isPending };
};
